import dynamic      from "next/dynamic";
import { useState } from "react";

import { useGetAdConfig }   from "_common/hooks/global";
import { useGetDeviceType } from "_common/hooks/global";
import { useGetDarkMode }   from "_common/hooks/global";

const AdSlot         = dynamic ( () => import ( "_components/features/ads/slot" ) );
const Advertisement1 = dynamic ( () => import ( "_components/features/ads/feedMobile" ) );
const Advertisement2 = dynamic ( () => import ( "_components/features/ads/homeFeedDesktop" ) );

const component = ( { idx } ) => {
	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	if ( isMobile )
		return <MobileAd idx = { idx } />;

	return <DesktopAd idx = { idx } />;
};

const MobileAd = ( { idx } ) => {
	const { RECOMMENDED_FEED_MWEB: config } = useGetAdConfig ();
	const darkMode                          = useGetDarkMode ();

	if ( !config?.enabled )
		return null;

	if ( ( idx % config?.frequency ) !== config?.offset )
		return null;

	if ( config?.adManager === "vmax" )
		return (
			<Advertisement1 id = { config?.adUnitId } />
		);

	const path = darkMode ? config?.slotId?.dark : config?.slotId?.light;

	return (
		<AdSlot
			id    = { "gpt-passback" }
			index = { idx }
			path  = { path }
			size  = { config?.size }
		/>
	);
};

const DesktopAd = ( { idx } ) => {
	const { LIVE_RECOMMENDED_FEED_WEB: config } = useGetAdConfig ();
	const darkMode                              = useGetDarkMode ();
	const [ loaded, setLoaded ]                 = useState ( false );

	if ( !config?.enabled )
		return null;

	if ( ( idx % config?.frequency ) !== config?.offset )
		return null;

	if ( config?.adManager === "vmax" )
		return (
			<Advertisement2 id = { config?.adUnitId } />
		);

	const adRendered = () => {
		setLoaded ( true );
	};

	const path = darkMode ? config?.slotId?.dark : config?.slotId?.light;

	return (
		<div style = { { display: loaded ? "block" : "none" } }>
			<AdSlot
				adRendered = { adRendered }
				id         = { "gpt-passback" }
				index      = { idx }
				path       = { path }
				size       = { config?.size }
			/>
		</div>
	);
};

export default component;
